// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"sm","place_order_copy":"tm","next_order_copy":"um","title_wrapper":"vm","get_it_now_row":"wm","get_it_now_remaining_items":"xm","get_it_now_remaining_items_mob":"ym","order_summary":"zm","additional_items":"Am","account_content_slider":"Bm","ingredient_carousel":"Cm","ingredient_carouselwrapper":"Em","account_content_slide":"Fm","account_subscription_section_mob":"Gm","carouselwrapper":"Hm"};
    if(module.hot) {
      // 1726593103126
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  